import { LIST_PATHNAME_EDIT_CODE } from '@libs/constants'
export const HELP_LAUNCHER_HIDDEN_PATH_PREFIXES = [
  '/app/modal/',
  '/app/popup/',
  '/app/print/',
  '/app/orders/inline/',
  '/app/orders/send_email',
  '/app/orders/downloadfile',
  '/app/draft_orders/send_email',
  '/app/invoice_generator/customer_create',
  '/app/invoice_generator/product_create',
  '/app/invoice_generator/delete_confirm',
  '/app/reports/custom-theme',
  '/pdfoutput',
] as const

export const isHelpLauncherHiddenPath = (pathname: string) =>
  LIST_PATHNAME_EDIT_CODE.some((prefix) => pathname.startsWith(prefix)) ||
  HELP_LAUNCHER_HIDDEN_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
